import axios from 'axios';

import {
    API_BASE_URL,
    API_URL_GET_APP_DOCUMENTS,
    API_URL_UPLOAD_APP_DOCUMENTS
} from '../constants';

export default class AppDocumentsService {
	static instance;

	static getInstance() {
		if (!AppDocumentsService.instance) {
			AppDocumentsService.instance = new AppDocumentsService();
		}

		return AppDocumentsService.instance;
	}

    async fetchList(params = {}){
        const response = await axios.get(API_URL_GET_APP_DOCUMENTS, {
            params: params,
            headers: {
                Authorization: `Bearer ${localStorage.getItem(
                    "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                )}`
            }
        });
        return response.data.data || []
    }

    async create(payload){
        const response = await axios.post(API_URL_UPLOAD_APP_DOCUMENTS, payload, {
            headers :   {
                Authorization: `Bearer ${localStorage.getItem(
                    "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                )}`
            }
        });

        return response
    }

    async delete(id){
        return await axios.delete(`${API_BASE_URL}/user_manual/${id}/delete`, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem(
                    "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                )}`
            }
        })
    }
    
    async updateRole(id, payload){
        const response = await axios.post(
            `${API_BASE_URL}/user_manual/${id}/edit`, 
            payload, 
            {
                headers :   {
                    Authorization: `Bearer ${localStorage.getItem(
                        "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                    )}`
                }
            }
        );

        return response
    }
}
